module.exports = __webpack_public_path__ + "static/media/Dr-Cristian-Acquisto.45a0855a.jpg";